import { axiosInstance } from '@configs/axios/axiosInstance';

import type { SfContactResponse } from './getSfContact.types';

/**
 * Get Salesforce contact details
 * Endpoint: GET /sf-redirect/contacts/{sfMasterContactId}
 *
 * Returns contact information with discrepancy check.
 * The `isOnboarded` flag indicates whether the user exists in CAE Connect.
 * The `discrepancyType` indicates if there are data conflicts to resolve.
 */
export async function getSfContact(
  sfMasterContactId: string,
  sfAccountId: string
): Promise<SfContactResponse> {
  const { data } = await axiosInstance.get<SfContactResponse>(
    `/sf-redirect/contacts/${encodeURIComponent(sfMasterContactId)}`,
    {
      headers: {
        'X-Salesforce-Account-Id': sfAccountId,
      },
    }
  );
  return data;
}
